var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6135 6.70711C15.2229 6.31658 15.2229 5.68342 15.6135 5.29289C16.004 4.90237 16.6371 4.90237 17.0277 5.29289L23.0277 11.2929C23.4182 11.6834 23.4182 12.3166 23.0277 12.7071L17.0277 18.7071C16.6371 19.0976 16.004 19.0976 15.6135 18.7071C15.2229 18.3166 15.2229 17.6834 15.6135 17.2929L19.9064 13H2.33134C1.77297 13 1.32031 12.5523 1.32031 12C1.32031 11.4477 1.77297 11 2.33134 11H19.9063L15.6135 6.70711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerRight);
export default __webpack_public_path__ + "static/media/pointer-right.b4324838c5d26e2a8ebb77f55f71e0a5.svg";
export { ForwardRef as ReactComponent };